import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import fetchPFP from '../functions/fetchPFP';
import LazyImage from './shared/LazyImage';
import fetchUsernameWithUID from '../functions/fetchUsernameWithUID';

export const PostPreview = (pid={ pid }) => {
    const [post, setPost] = useState(null);
    const [profilePicture, setProfilePicture] = useState(null);
    const [username, setUsername] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch the post document from Firestore
                const postRef = doc(db, 'posts', pid.post);
                const postDoc = await getDoc(postRef);

                if (!postDoc.exists()) {
                    console.error('Post not found');
                    return;
                }

                const postData = postDoc.data();
                setPost(postData);

                // Cache the post data in sessionStorage
                sessionStorage.setItem(`post_${pid.post}`, JSON.stringify(postData));
                console.log('Post fetched from Firestore and cached');


            } catch (error) {
                console.error('Error fetching post:', error);
            }
        };

        fetchData();
    }, [pid]);


    console.log("pid in pp", pid   );

    return (
        <Link to={`/post/${pid.post}`}>
            <div className="shadow-md flex p-4 flex-row h-24 sm:h-48 overflow-clip relative">
                {/* dangerouslySetInnerHTML allows us to render HTML */}
                <div
                    className="ml-4"
                    dangerouslySetInnerHTML={{ __html: post?.text }}
                />
                <div className="absolute inset-x-0 bottom-0 h-1/5 bg-gradient-to-b from-transparent to-white" />
            </div>
        </Link>
    );
};  